import { render, staticRenderFns } from "./CalculateResultItem.vue?vue&type=template&id=53bbd549"
import script from "./CalculateResultItem.vue?vue&type=script&lang=js"
export * from "./CalculateResultItem.vue?vue&type=script&lang=js"
import style0 from "./CalculateResultItem.vue?vue&type=style&index=0&id=53bbd549&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports